<template lang="pug">
  div(class="user-list-item" )
    div
      span {{user.name}}
    div(:style="")
      span(:style="textColor") {{user.amountOfCan}}
      img(:src="selected ? require('@/assets/icon/person_menu_trash_select.svg') : require('@/assets/icon/person_menu_trash_normal.svg')")
      img(:src="selected ? require('@/assets/icon/area_menu_more_select.svg'): require('@/assets/icon/area_menu_more_normal.svg')"
        @click="toggleUserMenu()" ref="button")
    //- div(class="user-menu" :ref="`menu_${index}`" )
    //-   span(@click="modifyUser()" ref="button") 編輯
    //-   span(@click="deleteUser()" ref="button") 刪除
</template>
<script>
import { mapMutations } from 'vuex'
//  v-click-outside="toggleUserMenu()"
export default {
  props: {
    user: Object,
    selected: {
      default: false,
      type: Boolean
    },
    index: Number
  },
  data () {
    return {
      show: false
    }
  },
  computed: {
    textColor () {
      return (this.selected ? { color: 'white' } : { color: '#7e7e7e' })
    }
  },
  mounted () {
    this.$refs[`menu_${this.index}`].classList.add('hide')
  },
  methods: {
    ...mapMutations({
      SET_modal: 'SET_modal'
    }),
    toggleUserMenu () {
      this.show ? this.$refs[`menu_${this.index}`].classList.add('hide') : this.$refs[`menu_${this.index}`].classList.remove('hide')
      this.show = !this.show
    },
    modifyUser () {
      this.toggleUserMenu()
      this.SET_modal({
        isModalOpen: true,
        type: 'addUser'
      })
    },
    deleteUser () {
      this.toggleUserMenu()
    },
    closeMenu () {
      this.$refs[`menu_${this.index}`].classList.add('hide')
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.user-list-item {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 58px;
  font-size: 12px;
  border-radius: 10px;
  border: 1px solid map-get($colors, border-color-gray);
  padding: 13px 5px 13px 15px;
  box-sizing: border-box;
  overflow: visible;
  cursor: pointer;
  > div:nth-child(1) {
    > span {
      font-size: 14px;
      color: mpa-get($colors, white);
      font-weight: bold;
    }
  }
  > div:nth-child(2) {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  > div:nth-child(3) {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    right: -70px;
    bottom: calc(50%-25) px;
    background-color: map-get($colors, white);
    border-radius: 5px;
    box-shadow: 0px 3px 12px rgba(black, 0.1);
    box-sizing: border-box;
    padding: 10px 25px;
    color: #018f6b;
    z-index: 999;
    > span:nth-child(2) {
      margin-top: 3px;
    }
    &::after {
      content: "";
      z-index: 999;
      left: -20px;
      top: 10px;
      position: absolute;
      clip-path: polygon(100% 0, 0 54%, 100% 100%);
      transform: translate3d(-50%, 0, 0);
      width: 20px;
      height: 10px;
      background-color: white;
    }
  }
}

.selected {
  color: map-get($colors, white);
  background-image: map-get($linear-gradient, primary);
}

.hide {
  display: none !important;
  background-color: red;
}
</style>
